<h2 mat-dialog-title>{{data.title}}</h2>
<div mat-dialog-content>{{data.message}}</div>
<div mat-dialog-actions [align]="'end'">
  <button *ngIf="data.alertType==='Warning'" mat-raised-button color="warn" mat-dialog-close>Close</button>
  <button *ngIf="data.alertType==='Success'" mat-raised-button class="button-success" mat-dialog-close>Close</button>
</div>
